import { Link } from 'react-router-dom';
import { ctaContent } from '@/mocks/homeData';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20green%20garden%20pathway%20lined%20with%20manicured%20hedges%20and%20beautiful%20flowering%20plants%2C%20soft%20golden%20sunset%20light%20creating%20warm%20atmosphere%2C%20peaceful%20and%20inviting%20landscape%20scene%2C%20professional%20garden%20design%20photography%2C%20dreamy%20natural%20bokeh%20background&width=1920&height=800&seq=cta-bg-section&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 to-black/45"></div>

      <div className="relative max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-5 leading-tight">
          {ctaContent.title}
        </h2>
        <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-8 max-w-xl mx-auto">
          {ctaContent.description}
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-medium text-background-50 bg-accent-500 rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
        >
          {ctaContent.buttonText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}